import React, { useContext, useMemo } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { SortableElement } from 'react-sortable-hoc';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import Handle from './Handle';
import Body from './index';
import { TicketContext } from '../..';
import { NEW_TICKET_OPEN_MODAL } from '../../reducer/actionTypes';
import {
  MODAL_ADD_FIELD,
  MODAL_ADD_SUBCATEGORY,
  MODAL_DELETE_CATEGORY,
  MODAL_DELETE_FIELD,
  MODAL_DELETE_SUBCATEGORY,
  MODAL_EDIT_CATEGORY,
  MODAL_EDIT_FIELD,
  MODAL_EDIT_SUBCATEGORY,
} from '../../constants/modals';
import Tooltip from '../../../../../components/Tooltip';

const Row = ({ parentIndex, item }) => {
  const { handleSortEnd, handleSortStart, dispatch } = useContext(TicketContext)
  const { access } = item;
  const showAction = useMemo(() => {
    if (access) {
      return Object.keys(access).some((key) => access[key] === true)
    }
    return false;
  }, [access])

  const onEditModal = (modalKey, data = {}) => {
    dispatch({
      type: NEW_TICKET_OPEN_MODAL,
      payload: {
        modalKey,
        data,
      },
    })
  }

  const onEditDeleteCategory = (modalKey) => {
    dispatch({
      type: NEW_TICKET_OPEN_MODAL,
      payload: {
        modalKey,
        data: item,
      },
    })
  }

  return (
    <>
      <Tooltip
        placement="top"
        text={item?.is_blocked && (
          <p>
            Field unavailable
            <br />
            {' '}
            because of using subcategory
          </p>
        )}
        tooltipClass="tooltip__top"
      >
        <div
          className={classNames('new-ticket__row', {
            'new-ticket__row-disabled': item?.is_blocked,
          })}
          data-parent-index={parentIndex}
          data-collection={item.collection}
        >
          <div className={classNames('new-ticket__row-left', {
            'new-ticket__row-left-2': item.item === 1,
            'new-ticket__row-left-3': item.item === 2,
          })}
          >
            <Handle />
            <div className={classNames('new-ticket__row-name', {
              'new-ticket__row-name-category': item.item === 0,
            })}
            >
              {item.name}
            </div>
          </div>
          <div className="new-ticket__row-actions">
            {showAction
              ? (
                <DropdownButton
                  bsSize="xsmall"
                  title="Actions"
                  id={`ticket-edit-actions-${item.id}`}
                >
                  {(() => {
                    switch (item.item) {
                    case 0:
                      return (
                        <>
                          {access?.edit ? <MenuItem eventKey={`${item.item}-${item.id}-1`} onClick={() => onEditModal(MODAL_EDIT_CATEGORY, item)}>Edit category</MenuItem> : null}
                          {access?.add_subcategory ? <MenuItem eventKey={`${item.item}-${item.id}-2`} onClick={() => onEditModal(MODAL_ADD_SUBCATEGORY, item)}>Add subcategory</MenuItem> : null}
                          {item.isAddField && access?.add_field ? <MenuItem eventKey={`${item.item}-${item.id}-3`} onClick={() => onEditModal(MODAL_ADD_FIELD, item)}>Add field</MenuItem> : null }
                          {access?.delete ? <MenuItem eventKey={`${item.item}-${item.id}-4`} onClick={() => onEditDeleteCategory(MODAL_DELETE_CATEGORY)}>Delete category</MenuItem> : null }
                        </>
                      );
                    case 1:
                      return (
                        <>
                          {access?.edit ? <MenuItem eventKey={`${item.item}-${item.id}-1`} onClick={() => onEditModal(MODAL_EDIT_SUBCATEGORY, item)}>Edit subcategory</MenuItem> : null }
                          {access?.add_field ? <MenuItem eventKey={`${item.item}-${item.id}-2`} onClick={() => onEditModal(MODAL_ADD_FIELD, item)}>Add field</MenuItem> : null }
                          {access?.delete ? <MenuItem eventKey={`${item.item}-${item.id}-3`} onClick={() => onEditDeleteCategory(MODAL_DELETE_SUBCATEGORY)}>Delete subcategory</MenuItem> : null }
                        </>
                      );
                    case 2:
                      return (
                        <>
                          {!item?.is_blocked && access?.edit ? <MenuItem eventKey={`${item.item}-${item.id}-1`} onClick={() => onEditModal(MODAL_EDIT_FIELD, item)}>Edit field</MenuItem> : null }
                          {!item?.is_blocked && access?.add_field ? <MenuItem eventKey={`${item.item}-${item.id}-2`} onClick={() => onEditModal(MODAL_ADD_FIELD, item)}>Add field</MenuItem> : null }
                          {access?.delete ? <MenuItem eventKey={`${item.item}-${item.id}-3`} onClick={() => onEditDeleteCategory(MODAL_DELETE_FIELD)}>Delete field</MenuItem> : null }
                        </>
                      );
                    default:
                      return null;
                    }
                  })()}
                </DropdownButton>
              ) : null }
          </div>
        </div>
      </Tooltip>
      {item.children?.length
        ? (
          <Body
            handleSortEnd={handleSortEnd}
            handleSortStart={handleSortStart}
            items={item.children}
            parentIndex={parentIndex}
            parentId={item.id}
          />
        )
        : null}
    </>
  )
}

Row.propTypes = {
  parentIndex: PropTypes.number,
  item: PropTypes.object,
};

export default SortableElement(Row);
